import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M7.5 6.25a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5" />
    <path
      fillRule="evenodd"
      d="M11.172 1.25c.73 0 1.429.29 1.944.806l8.706 8.706a3.176 3.176 0 0 1 0 4.476l-6.584 6.584a3.176 3.176 0 0 1-4.476 0l-8.706-8.706a2.75 2.75 0 0 1-.806-1.944V4A2.75 2.75 0 0 1 4 1.25zM4 2.75A1.25 1.25 0 0 0 2.75 4v7.172l.006.123c.028.286.155.556.36.76l8.702 8.703a1.677 1.677 0 0 0 2.364 0l6.578-6.578a1.676 1.676 0 0 0 0-2.36l-8.704-8.704a1.25 1.25 0 0 0-.761-.36l-.123-.006z"
      clipRule="evenodd"
    />
  </>
);

const Tag = Icon('tag', svgContents);

export default Tag;
